import React from "react";
import { useEffect } from "react";
import $ from "jquery";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { API_POST } from "../General/Utility";
function PosView(props) {
  const dispatch = useDispatch();
  const _AuthParems = useSelector((state) => state.Common.Admin);
  const [strSearch, setstrSearch] = useState("");
  const [iVouchId, setiVouchId] = useState(0);
  const [strFromDate, setstrFromDate] = useState("");
  const [strToDate, setstrToDate] = useState("");
  const [arrEntVoucher, setarrEntVoucher] = useState([]);
  const [arrEntTableCol, setarrEntTableCol] = useState([]);
  useEffect(() => {
    $("[tabindex=52]").focus();
    Load_Vouchers();
    short_cut_keypress();
  }, []);
  const Load_Vouchers = async () => {
    const parems = {
      iBranchId: Number(_AuthParems.Branch),
      strFromDate: "",
      strToDate: "",
      strSearch: "",
      iScrId: 93,
      strDBName: _AuthParems.DB,
      iCounterId: Number(_AuthParems.Counter),
    };
    const res = await API_POST(`POS/Load_Vouchers/`, parems, dispatch);
    if (res) {
      setarrEntVoucher(res.Vouchers);
      setarrEntTableCol(res.EntTablDesign);
      setstrFromDate(res.strFromDate);
      setstrToDate(res.strToDate);
    }
  };
  const Search_Vouchers = async (value, SearchFor) => {
    setiVouchId(0);
    let FromDate = strFromDate;
    let ToDate = strToDate;
    let Search = strSearch;
    switch (SearchFor) {
      case "Search":
        setstrSearch(value);
        Search = value;
        break;
      case "From":
        setstrFromDate(value);
        FromDate = value;
        break;
      case "To":
        setstrToDate(value);
        ToDate = value;
        break;
      default:
        break;
    }
    const parems = {
      iBranchId: Number(_AuthParems.Branch),
      strFromDate: FromDate,
      strToDate: ToDate,
      strSearch: Search,
      iScrId: 93,
      strDBName: _AuthParems.DB,
      iCounterId: Number(_AuthParems.Counter),
    };
    const res = await API_POST(`POS/Search_Vouchers/`, parems, dispatch);
    if (res) {
      setarrEntVoucher(res.Vouchers);
    }
  };
  const short_cut_keypress = () => {
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        e.preventDefault();
        props.Close();
      }
    });
  };
  const Key_Down = (e) => {
    var ActiveIndex = document.activeElement.tabIndex;
    if (e.key === "ArrowLeft") {
      if (ActiveIndex > 1 && ActiveIndex <= 3)
        $("[tabindex='" + (ActiveIndex - 1) + "']").focus();
      else $("[tabindex='" + 4 + "']").focus();
    }
    if (e.key === "ArrowRight") {
      if (ActiveIndex >= 1 && ActiveIndex < 3)
        $("[tabindex='" + (ActiveIndex + 1) + "']").focus();
      else $("[tabindex='" + 1 + "']").focus();
    } else if (e.key === "Enter") {
      if (ActiveIndex >= 1 && ActiveIndex < 3)
        $("[tabindex='" + (ActiveIndex + 1) + "']").focus();
      else $("[tabindex='" + 1 + "']").focus();
    }
  };

  return (
    <div className="popup-container">
      <div className="popup-content">
        <div className="popup-header">
          <h5>POS Invoice</h5>
          <div className="icon-popup-btn-grp">
            <span className="icon-btn" onClick={props.Close}>
              <i className="fa-regular fa-rectangle-xmark"></i>
            </span>
          </div>
        </div>
        <div className="popup-body p-1">
          <div className="row ">
            <div className="col-md-6 col-sm-12 mb-1 pl-1">
              <div className="m-hsearch ">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search"
                  autoFocus
                  autoComplete="off"
                  id="Invoice_Search"
                  onKeyDown={(e) => {
                    if (
                      e.key === "Enter" ||
                      e.key === "ArrowUp" ||
                      e.key === "ArrowDown"
                    );
                  }}
                  tabIndex={52}
                  name="strSearch"
                  value={strSearch}
                  onChange={(e) => Search_Vouchers(e.target.value, "Search")}
                />
                <i
                  className="fas fa-search"
                  onClick={(e) => Search_Vouchers(strSearch, "Search")}
                ></i>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 mb-1">
              <input
                type="date"
                className="form-control"
                value={strFromDate}
                name="strFromDate"
                tabIndex={2}
                onKeyDown={(e) => Key_Down(e)}
                onChange={(e) => Search_Vouchers(e.target.value, "From")}
              />
            </div>
            <div className="col-md-3 col-sm-6 mb-1">
              <input
                type="date"
                onKeyDown={(e) => Key_Down(e)}
                tabIndex={3}
                className="form-control"
                value={strToDate}
                name="strToDate"
                onChange={(e) => Search_Vouchers(e.target.value, "To")}
              />
            </div>
            <div className="table-card mt-1">
              <table className="option-list">
                <thead>
                  <tr>
                    {arrEntTableCol.map(
                      (ht, Index) =>
                        ht.isShow && <th key={Index}>{ht.strAliasName}</th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {arrEntVoucher.map((voucher, Index) => (
                    <tr
                      key={Index}
                      tabIndex={Index}
                      onKeyDown={(e) => {
                        const arrlength = arrEntVoucher.length - 1;
                        if (e.key === "ArrowDown") {
                          if (Index === arrlength)
                            $(`.option-list [tabindex=${0}]`).focus();
                          else
                            $(`.option-list [tabindex=${Index + 1}]`).focus();
                        }
                        if (e.key === "ArrowUp") {
                          if (Index === 0)
                            $(`.option-list [tabindex=${arrlength}]`).focus();
                          else
                            $(`.option-list [tabindex=${Index - 1}]`).focus();
                        }
                        if (e.key === "ArrowLeft") $("#to_date").focus();
                        if (e.key === "ArrowRight")
                          $("#Invoice_Search").focus();
                        if (e.key === "Enter")
                          props.ViewInvoice(voucher.vouchId);
                      }}
                      onClick={(e) => setiVouchId(voucher.vouchId)}
                      onDoubleClick={(e) => props.ViewInvoice(voucher.vouchId)}
                    >
                      {arrEntTableCol.map(
                        (dt, Index) =>
                          dt.isShow && (
                            <td
                              key={Index}
                              style={{
                                textAlign: dt.strTextAlign,
                                width: dt.strWidth.includes("%")
                                  ? dt.strWidth
                                  : dt.strWidth + "px",
                                maxWidth: dt.strWidth.includes("%")
                                  ? dt.strWidth
                                  : dt.strWidth + "px",
                                color: "black",
                              }}
                            >
                              {dt.strDataType === "number"
                                ? Number(voucher[dt.strColName]).toFixed(2)
                                : voucher[dt.strColName]}
                            </td>
                          )
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="pos-btn-group">
          <div className="pos-tooltip">
            <a className="icon-btn" href="##">
              <i className="fa-solid fa-print"></i>
            </a>
            <span className="pos-tooltiptxt">Print</span>
          </div>
          <div className="pos-tooltip">
            <a className="icon-btn" href="##">
              <i className="fa-solid fa-download"></i>
            </a>
            <span className="pos-tooltiptxt">Download</span>
          </div>
          <div className="pos-tooltip" onClick={(e) => props.Return(iVouchId)}>
            <a className="icon-btn" href="##">
              <i className="fa-solid fa-arrow-rotate-left"></i>
            </a>
            <span className="pos-tooltiptxt">Return</span>
          </div>
          <div className="pos-tooltip">
            <a className="icon-btn" href="##">
              <i className="fa-brands fa-whatsapp"></i>
            </a>
            <span className="pos-tooltiptxt">whatsapp</span>
          </div>
          <div className="pos-tooltip">
            <a className="icon-btn" href="##">
              <i className="fa-regular fa-envelope"></i>
            </a>
            <span className="pos-tooltiptxt">E-mail</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PosView;
